const FinalStateReducer = (state = {}, action) => {
    switch (action.type) {
        case 'SET_FINAL_STATE':
            const resetFinalStateNodes = {};
            action.payload.forEach(key => resetFinalStateNodes[key] = (state.finalStateData && state.finalStateData[key]) || {spin: 0, parity: 1, name:"P" + key});
            resetFinalStateNodes["0"] = {spin: 0, parity: 1, name:"P0", parityConserved: false};
            return {"nodes": action.payload, "finalStateData": {...resetFinalStateNodes}};
        case "SET_FINAL_STATE_DATA":
            return {"nodes": state.nodes, "finalStateData": action.payload};
        default:
            return state;
    }
}

export default FinalStateReducer;